// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import common from "@store/Themes/common/styleguide/components/panelMenu";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

const panelMenu: Styleguide["panelMenu"] = {
    defaultProps: {
        ...common?.defaultProps,
        childTypographyProps: {
            ...common?.defaultProps?.childTypographyProps,
            color: "text.main",
        },
        panelRowProps: {
            ...common?.defaultProps?.panelRowProps,
            moreIconProps: {
                ...common?.defaultProps?.panelRowProps?.moreIconProps,
                css: css`
                    color: ${getColor("text.main")};
                `,
            },
            css: css`
                ${common?.defaultProps?.panelRowProps?.css}
                padding: ${pxToRem(20)};

                * {
                    color: ${getColor("text.main")};
                }
            `,
            isCurrentCss: css`
                background-color: #f3f5f7; /* common.accent color, getColor and resolveColor don't work */
                border-bottom: ${pxToRem(1)} solid ${getColor("common.border")};
            `,
        },
    },
};

export default panelMenu;
